export const campaing_types = [
  { id: 1, value: 'WHATSAPP', display: 'WHATSAPP', campaign_type: 'WHATSAPP', hasAI: false },
  // { id: 2, value: 'WHATSAPP_AI', display: 'WHATSAPP COM IA', campaign_type: 'WHATSAPP', hasAI: true },
  { id: 3, value: 'SMS', display: 'SMS', campaign_type: 'SMS', hasAI: false },
  // { id: 4, value: 'SMS_AI', display: 'SMS COM IA', campaign_type: 'SMS', hasAI: true },
  { id: 5, value: 'RCS', display: 'RCS', campaign_type: 'RCS', hasAI: false },
  { id: 6, value: 'EMAIL', display: 'EMAIL', campaign_type: 'EMAIL', hasAI: false },
];
